export { default } from './component';


// WEBPACK FOOTER //
// ./components/Agile/product/index.js